import getPhoneticSystem from '../systems/getPhoneticSystem';

const markSyllableBoundaries = (message: string, system: string): string => (
    message ? getPhoneticSystem(system).markSyllableBoundaries(message) : ''
);

export default markSyllableBoundaries;
